import React from 'react'
import { useSelector } from 'react-redux'

import { LineChart } from 'components/Charts'
import { QUALITY, HEADER } from 'constants/forioVariables'
import { CONSTANTS } from 'constants/constants'

const { CALIDAD_PERCIBIDA } = QUALITY
const { TIME } = HEADER
const { PERCEIVED_QUALITY } = CONSTANTS

const returnData = (variables, time) => {
  return {
    labels: time ? time[TIME] : [0],
    datasets: [
      {
        label: PERCEIVED_QUALITY,
        fill: false,
        borderColor: '#4bc0c0',
        data: variables[CALIDAD_PERCIBIDA],
      },
    ],
  }
}

const PerceivedQuality = () => {
  const variables = useSelector(state => state.quality.variablesChartPerceivedQuality)

  const time = useSelector(state => state.header.variablesHeader)
  return time && time[TIME] ? (
    <LineChart data={returnData(variables, time)} titleChart={PERCEIVED_QUALITY} />
  ) : null
}
export default PerceivedQuality
